import { TFunction } from 'i18next'

import { SelectOption, SelectProps } from 'components/Select'

type OptionsWithNoneProps<T> = Pick<SelectProps<T>, 'optional' | 'options'> & {
  t: TFunction<'components'>
}

export const optionsWithNone = <T>({
  optional,
  options,
  t,
}: OptionsWithNoneProps<T>): SelectOption<T>[] =>
  optional
    ? [
        {
          label: t('select.noneOptionLabel'),
          value: '',
        },
        ...options,
      ]
    : options
